import { render } from "./Chyron.vue?vue&type=template&id=74e1a998&scoped=true"
import script from "./Chyron.vue?vue&type=script&lang=js"
export * from "./Chyron.vue?vue&type=script&lang=js"

import "@/Common/Styles/chyron.scss?vue&type=style&index=0&id=74e1a998&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e1a998"]])

export default __exports__